// import React, { useState } from 'react';
// import { Button, TextField, MenuItem, Typography, Container, Box } from '@mui/material';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const Login = () => {
//   const [department, setDepartment] = useState('');
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     try {
//       const response = await axios.post('http://localhost:5000/api/login', {
//         department, username, password
//       });

//       if (response.status === 200) {
//         alert('Login successful!');
//         navigate('/register');
//       }
//     } catch (error) {
//       alert('Invalid credentials!');
//     }
//   };

//   return (
//     <Container maxWidth="xs"> {/* Reduced width from 'sm' to 'xs' */}
//       <Box
//         sx={{
//           mt: 6,
//           p: 3,
//           boxShadow: 3,
//           borderRadius: 2,
//           minHeight: '350px',   // Reduced height
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center'
//         }}
//       >
//         <Typography variant="h5" gutterBottom align="center">
//           Login
//         </Typography>

//         <TextField
//           select
//           label="Department"
//           value={department}
//           onChange={e => setDepartment(e.target.value)}
//           fullWidth
//           margin="normal"
//         >
//           <MenuItem value="Audiology">Audiology</MenuItem>
//           <MenuItem value="Speech">Speech</MenuItem>
//         </TextField>

//         <TextField
//           label="Username"
//           value={username}
//           onChange={e => setUsername(e.target.value)}
//           fullWidth
//           margin="normal"
//         />

//         <TextField
//           label="Password"
//           type="password"
//           value={password}
//           onChange={e => setPassword(e.target.value)}
//           fullWidth
//           margin="normal"
//         />
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={handleLogin}
//           fullWidth
//           sx={{ mt: 2 }}
//           disabled={!department}
//         >
//           Login
//         </Button>

//       </Box>
//     </Container>
//   );
// };

// export default Login;
import React, { useState } from 'react';
import { Button, TextField, MenuItem, Typography, Container, Box } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [department, setDepartment] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/login`, {
        department, 
        username, 
        password
      });

      if (response.status === 200) {
      
        // Save department to localStorage
        localStorage.setItem('department', department);
        
        // Determine navigation based on department
        if (department === 'Speech' || department === 'Audiology') {
          navigate('/register');
        } else {
          navigate('/demography');
        }
      }
    } catch (error) {

    }
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          mt: 6,
          p: 3,
          boxShadow: 3,
          borderRadius: 2,
          minHeight: '350px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Typography variant="h5" gutterBottom align="center">
          Login
        </Typography>

        <TextField
          select
          label="Department/Clinic/Unit"
          value={department}
          onChange={e => setDepartment(e.target.value)}
          fullWidth
          margin="normal"
        >
          <MenuItem value="Audiology">Audiology</MenuItem>
          <MenuItem value="Speech">Speech</MenuItem>
          <MenuItem value="Outreach">Outreach</MenuItem>
          <MenuItem value="GHWC">GHWC</MenuItem>
          <MenuItem value="School Screening">SchoolScreening</MenuItem>
          <MenuItem value="NBHS">NBHS</MenuItem>
          <MenuItem value="Payment">Payment</MenuItem>
       
        </TextField>

        <TextField
          label="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          fullWidth
          margin="normal"
        />

        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          fullWidth
          margin="normal"
        />
        
        <Button
          variant="contained"
          color="primary"
          onClick={handleLogin}
          fullWidth
          sx={{ mt: 2 }}
          disabled={!department}
        >
          Login
        </Button>
      </Box>
    </Container>
  );
};

export default Login;